import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Permissions } from '../models/permissions.model';
import { AuthService } from '../services/auth.service';
import { PermissionsService } from '../services/permissions.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionsService);

  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return router.parseUrl('/auth/login');
  }

  const userLoaded = authService.getUser();
  const permissions = new Permissions();
  permissions.permissions = userLoaded.permissions;
  permissions.roles = userLoaded.roles;

  permissionService.setPermissions(permissions);

  return true;
};
